// Unified Training Requests

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { cloneDeep } from 'lodash';
import { MenuItem, TreeNode } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

@Component({
  selector: 'app-unified-trining-req',
  templateUrl: './unified-trining-req.component.html',
  styleUrls: ['./unified-trining-req.component.scss']
})
export class UnifiedTriningReqComponent {
  @Input() trainingRequest: any
  @Input() treeFilter : any
  @Output() closeUnified: EventEmitter<any> = new EventEmitter();


  selectedTreeData : any = []
  orgUnit: any = undefined


  constructor(
    private dataService: DataService,
    // private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private orgUnits: OrgUnitsService,
  ) { }

  staticURL = GlobalConstants.staticFilesURL;

  allowedRight = ['Ministries/Entities', 'Organisational Units', 'Branches']


  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  


  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }

  availableMonths: any[] = [];
  selectedMonths: any[] = [];
  year: any = ''


  ngOnInit() {
    this.year = new Date().getFullYear();
    this.getTreeData(),
      this.selectedMonths = [];
    this.availableMonths = [
      { name: "يناير", id: 1, year: this.year },
      { name: "فبراير", id: 2, year: this.year },
      { name: "مارس", id: 3, year: this.year },
      { name: "أبريل", id: 4, year: this.year },
      { name: "مايو", id: 5, year: this.year },
      { name: "يونيو", id: 6, year: this.year },
      { name: "يوليو", id: 7, year: this.year },
      { name: "أغسطس", id: 8, year: this.year },
      { name: "سبتمبر", id: 9, year: this.year },
      { name: "أكتوبر", id: 10, year: this.year },
      { name: "نوفمبر", id: 11, year: this.year },
      { name: "ديسمبر", id: 12, year: this.year }
    ];

    const currentMonth = new Date().getMonth() + 1;

     this.availableMonths = this.availableMonths.filter(month => month.year > this.year  || (month.year === this.year  && month.id >= currentMonth));

  }

  async getTreeData() {
    let data : any= await await this.orgUnits.getOrgUnits()
    this.selectedTreeData = []

    //get weekly type
    let selectedid : any = this.treeFilter

    if (selectedid.label != 'الجهات المشاركة') {

      this.selectedTreeData.push(this.findNodeByName(data, selectedid._id))
      // Create a deep copy of the selected data using lodash.clonedeep
      this.selectedTreeData_orginal = cloneDeep(this.selectedTreeData);
      console.log("the selected tree 109", this.selectedTreeData);

      const uniqueTags = new Set()

      this.types.forEach((type: any) => {
        if (type && type.tag) {
          uniqueTags.add(type.tag);
        }
      });

      let uniqueTagsArray: MenuItem[] = []

      uniqueTags.forEach((item: any) => {
        if (item != "Ministries/Entities")
          uniqueTagsArray.push({ label: item });
      })

      this.selectedTreeTags = uniqueTagsArray;

      this.selectedTreeTags_current = this.selectedTreeTags[0]

      this.changeSelectedTag(this.selectedTreeTags_current);
    }
  }

  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      if (node._id === nodeName) {
        return node;
      }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Branches"
    };
    if (this.selectedTreeTags_current.label) {
      await this.filterTreeByTag("Branches");
    } else {
      this.selectedTreeData = null;
    }

  }

  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);

      console.log("cloneitems.children this.selectedTreeData", this.selectedTreeData);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }



  generateMonths() {
    this.year++;
    let months = [
      { name: "يناير", id: 1, year: this.year },
      { name: "فبراير", id: 2, year: this.year },
      { name: "مارس", id: 3, year: this.year },
      { name: "أبريل", id: 4, year: this.year },
      { name: "مايو", id: 5, year: this.year },
      { name: "يونيو", id: 6, year: this.year },
      { name: "يوليو", id: 7, year: this.year },
      { name: "أغسطس", id: 8, year: this.year },
      { name: "سبتمبر", id: 9, year: this.year },
      { name: "أكتوبر", id: 10, year: this.year },
      { name: "نوفمبر", id: 11, year: this.year },
      { name: "ديسمبر", id: 12, year: this.year }
    ];

    this.availableMonths = [...this.availableMonths, ...months];
  }


  yearChanged() {
    console.log("===this.yeat", this.year)
  }


  sortMonths() {
    this.availableMonths.sort((a, b) => {
      if (a.year !== b.year) {
        return a.year - b.year; // Sort by year first
      } else {
        return a.id - b.id; // If years are the same, sort by id
      }
    });
  }

  assignedList: any = []
  assignError = false
  // to assign organizational units
  assignOrgUnit() {

    console.log("====>Test", this.assignedList, this.orgUnit );
    this.assignError = false
    if(this.assignedList.some((item:any) => item.ou && item.ou._id === this.orgUnit._id)){
      this.assignError = true
      return
    }

    this.assignedList.push({
      ou: { ...this.orgUnit },
      date: {
        month: this.selectedMonths[0].name,
        year: this.selectedMonths[0].year,
        id: this.selectedMonths[0].id
      }
    })
    this.selectedMonths = []
    this.orgUnit = undefined
    console.log("assignedList==>", this.assignedList);
  }


  draggedProduct: any | undefined | null;

  dragStart(product: any) {
    this.draggedProduct = product;
  }


  deleteMonth(date: any, assignedOrg: any = null) {

    if (assignedOrg) {
      this.availableMonths.push({ name: date.month, id: date.id, year: date.year })
      assignedOrg.date = null
    } else {
      this.availableMonths.push(date)
      this.selectedMonths = []
    }
    this.sortMonths()
  }

  async sendRequest() {

    let dataToSend = [...this.assignedList]

    let ous  = dataToSend.flatMap(obj => obj.ou._id);

    

    const promises: any = dataToSend.forEach(async (item: any) => {

      let data = {
        topic: this.trainingRequest.topic,
        type: this.trainingRequest.type,
        description: this.trainingRequest.description,
        ou: item.ou._id,
        ous:ous,
        date: item.date
      }

      let res = await this.dataService.postData('training-req/', data);


      if (!res.error) {
        this.assignedList = this.assignedList.filter((item: any) => item.ou != data.ou)
        // remove item from assignedList
      }

      return null;

    })

    this.closeUnified.emit(false)
    this.assignedList = []
    this.year = new Date().getFullYear();
    this.selectedMonths = [];
    this.availableMonths = [
      { name: "يناير", id: 1, year: this.year },
      { name: "فبراير", id: 2, year: this.year },
      { name: "مارس", id: 3, year: this.year },
      { name: "أبريل", id: 4, year: this.year },
      { name: "مايو", id: 5, year: this.year },
      { name: "يونيو", id: 6, year: this.year },
      { name: "يوليو", id: 7, year: this.year },
      { name: "أغسطس", id: 8, year: this.year },
      { name: "سبتمبر", id: 9, year: this.year },
      { name: "أكتوبر", id: 10, year: this.year },
      { name: "نوفمبر", id: 11, year: this.year },
      { name: "ديسمبر", id: 12, year: this.year }
    ];

  }

  //drop on down cards
  drop2(assignedOrg: any) {

    if (this.draggedProduct) {
      if (assignedOrg.date) {
        this.availableMonths.push({ name: assignedOrg.date.month, id: assignedOrg.date.id, year: assignedOrg.date.year })
      }

      assignedOrg.date = { month: this.draggedProduct.name, id: this.draggedProduct.id, year: this.draggedProduct.year }
      let draggedProductIndex = this.findIndex(this.draggedProduct);
      // this.selectedMonths = [...(this.selectedMonths as any[]), this.draggedProduct];
      this.availableMonths = this.availableMonths?.filter((val, i) => i != draggedProductIndex);
      this.draggedProduct = null;
      this.sortMonths()
    }
  }



  drop() {

    console.log("Draged Profuct = >",this.draggedProduct, this.selectedMonths)

    if(this.selectedMonths.length > 0 ){
      this.availableMonths.push(this.selectedMonths[0])
      this.selectedMonths = []
    }


    if (this.draggedProduct) {
      let draggedProductIndex = this.findIndex(this.draggedProduct);
      this.selectedMonths = [...(this.selectedMonths as any[]), this.draggedProduct];
      this.availableMonths = this.availableMonths?.filter((val, i) => i != draggedProductIndex);
      this.draggedProduct = null;
    }
  }


  dragEnd() {
    this.draggedProduct = null;
  }

  deleteAssignment(assignedOrg : any){
    this.deleteMonth(assignedOrg.date, assignedOrg )
    this.assignedList = this.assignedList.filter((item:any)=> item.ou && item.ou._id !== assignedOrg.ou._id);

  }

  findIndex(product: any) {
    let index = -1;
    for (let i = 0; i < (this.availableMonths as any[]).length; i++) {
      if (product.id === (this.availableMonths as any[])[i].id) {
        index = i;
        break;
      }
    }
    return index;
  }

}